(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vis"));
	else if(typeof define === 'function' && define.amd)
		define(["vis"], factory);
	else if(typeof exports === 'object')
		exports["vue2vis"] = factory(require("vis"));
	else
		root["vue2vis"] = factory(root["vis"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 12);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Timeline_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Timeline_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Timeline_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Timeline_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Timeline_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Timeline_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vis = __webpack_require__(1);

var _utils = __webpack_require__(8);

//
//
//
//

exports.default = {
  name: 'timeline',
  props: {
    groups: {
      type: [Array, _vis.DataSet, _vis.DataView],
      default: function _default() {
        return [];
      }
    },
    items: {
      type: [Array, _vis.DataSet, _vis.DataView],
      default: function _default() {
        return [];
      }
    },
    events: {
      type: Array,
      default: function _default() {
        return ['click', 'contextmenu', 'currentTimeTick', 'doubleClick', 'drop', 'mouseOver', 'mouseDown', 'mouseUp', 'mouseMove', 'groupDragged', 'changed', 'rangechange', 'rangechanged', 'select', 'itemover', 'itemout', 'timechange', 'timechanged'];
      }
    },
    selection: {
      type: [Array, String],
      default: function _default() {
        return [];
      }
    },
    options: {
      type: Object
    }
  },
  data: function data() {
    return {
      visData: {
        items: null,
        groups: null
      }
    };
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(v) {
        this.timeline.setOptions(v);
      }
    },
    selection: {
      deep: false,
      handler: function handler(v) {
        this.timeline.setSelection(v);
      }
    }
  },
  methods: {
    addCustomTime: function addCustomTime(time, id) {
      return this.timeline.addCustomTime(time, id);
    },
    destroy: function destroy() {
      this.timeline.destroy();
    },
    fit: function fit() {
      this.timeline.fit();
    },
    focus: function focus(id, options) {
      this.timeline.focus(id, options);
    },
    getCurrentTime: function getCurrentTime() {
      return this.timeline.getCurrentTime();
    },
    getCustomTime: function getCustomTime(id) {
      return this.timeline.getCustomTime(id);
    },
    getEventProperties: function getEventProperties(event) {
      return this.timeline.getEventProperties(event);
    },
    getItemRange: function getItemRange() {
      return this.timeline.getItemRange();
    },
    getSelection: function getSelection() {
      return this.timeline.getSelection();
    },
    getVisibleItems: function getVisibleItems() {
      return this.timeline.getVisibleItems();
    },
    getWindow: function getWindow() {
      return this.timeline.getWindow();
    },
    moveTo: function moveTo(time, options) {
      this.timeline.moveTo(time, options);
    },
    on: function on(event, callback) {
      this.timeline.on(event, callback);
    },
    off: function off(event, callback) {
      this.timeline.off(event, callback);
    },
    redraw: function redraw() {
      this.timeline.redraw();
    },
    removeCustomTime: function removeCustomTime(id) {
      this.timeline.removeCustomTime(id);
    },
    setCurrentTime: function setCurrentTime(time) {
      this.timeline.setCurrentTime(time);
    },
    setCustomTime: function setCustomTime(time, id) {
      this.timeline.setCustomTime(time, id);
    },
    setCustomTimeTitle: function setCustomTimeTitle(title, id) {
      this.timeline.setCustomTimeTitle(title, id);
    },
    setData: function setData(object) {
      this.timeline.setData(object);
    },
    setGroups: function setGroups(groups) {
      this.timeline.setGroups(groups);
    },
    setItems: function setItems(items) {
      this.timeline.setItems(items);
    },
    setOptions: function setOptions(options) {
      this.timeline.setOptions(options);
    },
    setSelection: function setSelection(ids, options) {
      this.timeline.setSelection(ids, options);
    },
    setWindow: function setWindow(start, end, options, callback) {
      this.timeline.setWindow(start, end, options, callback);
    },
    toggleRollingMode: function toggleRollingMode() {
      this.timeline.toggleRollingMode();
    },
    zoomIn: function zoomIn(percentage, options, callback) {
      this.timeline.zoomIn(percentage, options, callback);
    },
    zoomOut: function zoomOut(percentage, options, callback) {
      this.timeline.zoomOut(percentage, options, callback);
    }
  },
  mounted: function mounted() {
    var _this = this;

    var container = this.$refs.visualization;

    this.visData.items = (0, _utils.mountVisData)(this, 'items');

    if (this.groups && this.groups.length > 0) {
      this.visData.groups = (0, _utils.mountVisData)(this, 'groups');
      this.timeline = new _vis.Timeline(container, this.visData.items, this.visData.groups, this.options);
    } else {
      this.timeline = new _vis.Timeline(container, this.visData.items, this.options);
    }

    this.events.forEach(function (eventName) {
      return _this.timeline.on(eventName, function (props) {
        return _this.$emit((0, _utils.translateEvent)(eventName), props);
      });
    });
  },
  created: function created() {
    // This should be a Vue data property, but Vue reactivity kinda bugs Vis.
    // See here for more: https://github.com/almende/vis/issues/2524
    this.timeline = null;
  },
  beforeDestroy: function beforeDestroy() {
    this.timeline.destroy();
  }
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Graph2d_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Graph2d_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Graph2d_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Graph2d_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Graph2d_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Graph2d_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vis = __webpack_require__(1);

var _utils = __webpack_require__(8);

//
//
//
//

exports.default = {
  name: 'graph2d',
  props: {
    groups: {
      type: [Array, _vis.DataSet, _vis.DataView],
      default: function _default() {
        return [];
      }
    },
    items: {
      type: [Array, _vis.DataSet, _vis.DataView],
      default: function _default() {
        return [];
      }
    },
    events: {
      type: Array,
      default: function _default() {
        return ['click', 'contextmenu', 'currentTimeTick', 'doubleClick', 'changed', 'rangechange', 'rangechanged', 'timechange', 'timechanged'];
      }
    },
    options: {
      type: Object
    }
  },
  data: function data() {
    return {
      visData: {
        items: null,
        groups: null
      }
    };
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(v) {
        this.graph2d.setOptions(v);
      }
    }
  },
  methods: {
    destroy: function destroy() {
      this.graph2d.destroy();
    },
    fit: function fit() {
      this.graph2d.fit();
    },
    getCurrentTime: function getCurrentTime() {
      return this.graph2d.getCurrentTime();
    },
    getCustomTime: function getCustomTime() {
      return this.graph2d.getCustomTime(id);
    },
    getDataRange: function getDataRange() {
      return this.graph2d.getDataRange();
    },
    getEventProperties: function getEventProperties(event) {
      return this.graph2d.getEventProperties(event);
    },
    getLegend: function getLegend(groupId, iconWidth, iconHeight) {
      return this.graph2d.getLegend(groupId, iconWidth, iconHeight);
    },
    getWindow: function getWindow() {
      return this.graph2d.getWindow();
    },
    isGroupVisible: function isGroupVisible(groupId) {
      return this.graph2d.isGroupVisible(groupId);
    },
    moveTo: function moveTo(time, options) {
      this.graph2d.moveTo(time, options);
    },
    on: function on(event, callback) {
      this.graph2d.on(event, callback);
    },
    off: function off(event, callback) {
      this.graph2d.off(event, callback);
    },
    redraw: function redraw() {
      this.graph2d.redraw();
    },
    setCurrentTime: function setCurrentTime(time) {
      this.graph2d.setCurrentTime(time);
    },
    setCustomTime: function setCustomTime(time) {
      this.graph2d.setCustomTime(time);
    },
    setGroups: function setGroups(groups) {
      this.graph2d.setGroups(groups);
    },
    setItems: function setItems(items) {
      this.graph2d.setItems(items);
    },
    setOptions: function setOptions(options) {
      this.graph2d.setOptions(options);
    },
    setWindow: function setWindow(start, end) {
      this.graph2d.setWindow(start, end);
    }
  },
  mounted: function mounted() {
    var _this = this;

    var container = this.$refs.visualization;
    this.visData.items = (0, _utils.mountVisData)(this, 'items');
    this.visData.groups = (0, _utils.mountVisData)(this, 'groups');
    this.graph2d = new _vis.Graph2d(container, this.visData.items, this.visData.groups, this.options);

    this.events.forEach(function (eventName) {
      return _this.graph2d.on(eventName, function (props) {
        return _this.$emit((0, _utils.translateEvent)(eventName), props);
      });
    });
  },
  created: function created() {
    // This should be a Vue data property, but Vue reactivity kinda bugs Vis.
    // See here for more: https://github.com/almende/vis/issues/2524
    this.graph2d = null;
  },
  beforeDestroy: function beforeDestroy() {
    this.graph2d.destroy();
  }
};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Network_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
/* harmony import */ var _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Network_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Network_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Network_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Network_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
 /* harmony default export */ __webpack_exports__["default"] = (_node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_Network_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vis = __webpack_require__(1);

var _utils = __webpack_require__(8);

//
//
//
//

exports.default = {
  name: 'network',
  props: {
    edges: {
      type: [Array, _vis.DataSet, _vis.DataView],
      default: function _default() {
        return [];
      }
    },
    nodes: {
      type: [Array, _vis.DataSet, _vis.DataView],
      default: function _default() {
        return [];
      }
    },
    events: {
      type: Array,
      default: function _default() {
        return ['click', 'doubleClick', 'oncontext', 'hold', 'release', 'select', 'selectNode', 'selectEdge', 'deselectNode', 'deselectEdge', 'dragStart', 'dragging', 'dragEnd', 'hoverNode', 'blurNode', 'hoverEdge', 'blurEdge', 'zoom', 'showPopup', 'hidePopup', 'startStabilizing', 'stabilizationProgress', 'stabilizationIterationsDone', 'stabilized', 'resize', 'initRedraw', 'beforeDrawing', 'afterDrawing', 'animationFinished', 'configChange'];
      }
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      visData: {
        nodes: null,
        edges: null
      }
    };
  },
  watch: {
    options: {
      deep: true,
      handler: function handler(o) {
        this.network.setOptions(o);
      }
    }
  },
  methods: {
    setData: function setData(n, e) {
      this.visData.nodes = Array.isArray(n) ? new _vis.DataSet(n) : n;
      this.visData.edges = Array.isArray(e) ? new _vis.DataSet(e) : e;
      this.network.setData(this.visData);
    },
    destroy: function destroy() {
      this.network.destroy();
    },
    getNode: function getNode(id) {
      return this.visData.nodes.get(id);
    },
    getEdge: function getEdge(id) {
      return this.visData.edges.get(id);
    },
    setOptions: function setOptions(options) {
      this.network.setOptions(options);
    },
    on: function on(event, callback) {
      this.network.moveTo(event, callback);
    },
    off: function off(event, callback) {
      this.network.moveTo(event, callback);
    },
    once: function once(event, callback) {
      this.network.moveTo(event, callback);
    },
    canvasToDom: function canvasToDom(p) {
      return this.network.canvasToDOM(p);
    },
    domToCanvas: function domToCanvas(p) {
      return this.network.DOMtoCanvas(p);
    },
    redraw: function redraw() {
      this.network.redraw();
    },
    setSize: function setSize(w, h) {
      this.network.setSize(w, h);
    },
    cluster: function cluster(options) {
      this.network.cluster(options);
    },
    clusterByConnection: function clusterByConnection(nodeId, options) {
      this.network.clusterByConnection(nodeId, options);
    },
    clusterByHubsize: function clusterByHubsize(hubsize, options) {
      this.network.clusterByHubsize(hubsize, options);
    },
    clusterOutliers: function clusterOutliers(options) {
      this.network.clusterOutliers(options);
    },
    findNode: function findNode(id) {
      return this.network.findNode(id);
    },
    getClusteredEdges: function getClusteredEdges(baseEdgeId) {
      return this.network.clustering.getClusteredEdges(baseEdgeId);
    },
    getBaseEdge: function getBaseEdge(clusteredEdgeId) {
      return this.network.clustering.getBaseEdge(clusteredEdgeId);
    },
    getBaseEdges: function getBaseEdges(clusteredEdgeId) {
      return this.network.clustering.getBaseEdges(clusteredEdgeId);
    },
    updateEdge: function updateEdge(startEdgeId, options) {
      this.network.clustering.updateEdge(startEdgeId, options);
    },
    updateClusteredNode: function updateClusteredNode(clusteredNodeId, options) {
      this.network.clustering.updateClusteredNode(clusteredNodeId, options);
    },
    isCluster: function isCluster(nodeId) {
      return this.network.isCluster(nodeId);
    },
    getNodesInCluster: function getNodesInCluster(clusterNodeId) {
      return this.network.getNodesInCluster(clusterNodeId);
    },
    openCluster: function openCluster(nodeId, options) {
      this.network.openCluster(nodeId, options);
    },
    getSeed: function getSeed() {
      return this.network.getSeed();
    },
    enableEditMode: function enableEditMode() {
      this.network.enableEditMode();
    },
    disableEditMode: function disableEditMode() {
      this.network.disableEditMode();
    },
    addNodeMode: function addNodeMode() {
      this.network.addNodeMode();
    },
    editNode: function editNode() {
      this.network.editNode();
    },
    addEdgeMode: function addEdgeMode() {
      this.network.addEdgeMode();
    },
    editEdgeMode: function editEdgeMode() {
      this.network.editEdgeMode();
    },
    deleteSelected: function deleteSelected() {
      this.network.deleteSelected();
    },
    getPositions: function getPositions(nodeIds) {
      return this.network.getPositions(nodeIds);
    },
    storePositions: function storePositions() {
      this.network.storePositions();
    },
    moveNode: function moveNode(nodeId, x, y) {
      this.network.moveNode(nodeId, x, y);
    },
    getBoundingBox: function getBoundingBox(nodeId) {
      return this.network.getBoundingBox(nodeId);
    },
    getConnectedNodes: function getConnectedNodes(nodeId, direction) {
      return this.network.getConnectedNodes(nodeId, direction);
    },
    getConnectedEdges: function getConnectedEdges(nodeId) {
      return this.network.getConnectedEdges(nodeId);
    },
    startSimulation: function startSimulation() {
      this.network.startSimulation();
    },
    stopSimulation: function stopSimulation() {
      this.network.stopSimulation();
    },
    stabilize: function stabilize(iterations) {
      this.network.stabilize(iterations);
    },
    getSelection: function getSelection() {
      return this.network.getSelection();
    },
    getSelectedNodes: function getSelectedNodes() {
      return this.network.getSelectedNodes();
    },
    getSelectedEdges: function getSelectedEdges() {
      return this.network.getSelectedEdges();
    },
    getNodeAt: function getNodeAt(p) {
      return this.network.getNodeAt(p);
    },
    getEdgeAt: function getEdgeAt(p) {
      return this.network.getEdgeAt(p);
    },
    selectNodes: function selectNodes(nodeIds, highlightEdges) {
      this.network.selectNodes(nodeIds, highlightEdges);
    },
    selectEdges: function selectEdges(edgeIds) {
      this.network.selectEdges(edgeIds);
    },
    setSelection: function setSelection(selection, options) {
      this.network.setSelection(selection, options);
    },
    unselectAll: function unselectAll() {
      this.network.unselectAll();
    },
    getScale: function getScale() {
      return this.network.getScale();
    },
    getViewPosition: function getViewPosition() {
      return this.network.getViewPosition();
    },
    fit: function fit(options) {
      this.network.fit(options);
    },
    focus: function focus(nodeId, options) {
      this.network.focus(nodeId, options);
    },
    moveTo: function moveTo(options) {
      this.network.moveTo(options);
    },
    releaseNode: function releaseNode() {
      this.network.releaseNode();
    },
    getOptionsFromConfigurator: function getOptionsFromConfigurator() {
      return this.network.getOptionsFromConfigurator();
    }
  },
  created: function created() {
    // This should be a Vue data property, but Vue reactivity kinda bugs Vis.
    // See here for more: https://github.com/almende/vis/issues/2524
    this.network = null;
  },
  mounted: function mounted() {
    var _this = this;

    var container = this.$refs.visualization;
    this.visData.nodes = (0, _utils.mountVisData)(this, 'nodes');
    this.visData.edges = (0, _utils.mountVisData)(this, 'edges');
    this.network = new _vis.Network(container, this.visData, this.options);

    this.events.forEach(function (eventName) {
      return _this.network.on(eventName, function (props) {
        return _this.$emit((0, _utils.translateEvent)(eventName), props);
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.network.destroy();
  }
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateEvent = exports.mountVisData = exports.arrayDiff = undefined;

var _vis = __webpack_require__(1);

var arrayDiff = function arrayDiff(arr1, arr2) {
  return arr1.filter(function (x) {
    return arr2.indexOf(x) === -1;
  });
};

var mountVisData = function mountVisData(vm, propName) {
  var data = vm[propName];
  // If data is DataSet or DataView we return early without attaching our own events
  if (!(vm[propName] instanceof _vis.DataSet || vm[propName] instanceof _vis.DataView)) {
    data = new _vis.DataSet(vm[propName]);
    // Rethrow all events
    data.on('*', function (event, properties, senderId) {
      return vm.$emit(propName + '-' + event, { event: event, properties: properties, senderId: senderId });
    });
    // We attach deep watcher on the prop to propagate changes in the DataSet
    var callback = function callback(value) {
      if (Array.isArray(value)) {
        var newIds = new _vis.DataSet(value).getIds();
        var diff = arrayDiff(vm.visData[propName].getIds(), newIds);
        vm.visData[propName].update(value);
        vm.visData[propName].remove(diff);
      }
    };

    vm.$watch(propName, callback, {
      deep: true
    });
  }

  // Emitting DataSets back
  vm.$emit(propName + '-mounted', data);

  return data;
};

var translateEvent = function translateEvent(event) {
  return event.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
};

exports.arrayDiff = arrayDiff;
exports.mountVisData = mountVisData;
exports.translateEvent = translateEvent;

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Timeline.vue?vue&type=template&id=7ba4fae9&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"visualization"})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Timeline.vue?vue&type=template&id=7ba4fae9&
/* concated harmony reexport render */__webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* concated harmony reexport staticRenderFns */__webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Graph2d.vue?vue&type=template&id=fd73a97a&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"visualization"})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Graph2d.vue?vue&type=template&id=fd73a97a&
/* concated harmony reexport render */__webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* concated harmony reexport staticRenderFns */__webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Network.vue?vue&type=template&id=32865d28&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"visualization"})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Network.vue?vue&type=template&id=32865d28&
/* concated harmony reexport render */__webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* concated harmony reexport staticRenderFns */__webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataView = exports.DataSet = exports.Network = exports.Graph2d = exports.Timeline = undefined;

var _vis = __webpack_require__(1);

var _Timeline = __webpack_require__(13);

var _Timeline2 = _interopRequireDefault(_Timeline);

var _Graph2d = __webpack_require__(14);

var _Graph2d2 = _interopRequireDefault(_Graph2d);

var _Network = __webpack_require__(15);

var _Network2 = _interopRequireDefault(_Network);

__webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Timeline = _Timeline2.default;
exports.Graph2d = _Graph2d2.default;
exports.Network = _Network2.default;
exports.DataSet = _vis.DataSet;
exports.DataView = _vis.DataView;

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Timeline_vue_vue_type_template_id_7ba4fae9___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9);
/* harmony import */ var _Timeline_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Timeline_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Timeline_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _Timeline_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _Timeline_vue_vue_type_template_id_7ba4fae9___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _Timeline_vue_vue_type_template_id_7ba4fae9___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Timeline.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Graph2d_vue_vue_type_template_id_fd73a97a___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var _Graph2d_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Graph2d_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Graph2d_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _Graph2d_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _Graph2d_vue_vue_type_template_id_fd73a97a___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _Graph2d_vue_vue_type_template_id_fd73a97a___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Graph2d.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Network_vue_vue_type_template_id_32865d28___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11);
/* harmony import */ var _Network_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _Network_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _Network_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _Network_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["default"],
  _Network_vue_vue_type_template_id_32865d28___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _Network_vue_vue_type_template_id_32865d28___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

component.options.__file = "Network.vue"
/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ })
/******/ ]);
});
//# sourceMappingURL=vue2vis.min.js.map